import { useState, useEffect } from 'react';

export const useWindowSize = () => {
  const [widthSize, setWidthSize] = useState(window.innerWidth);
  const [heightSize, setHeightSize] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWidthSize(window.innerWidth);
      setHeightSize(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { widthSize, heightSize, isPortrait: heightSize > widthSize };
};
